module.exports = __webpack_public_path__ + "static/media/doc.62113e20.svg";